export const SYSTEM_FIELD_MAP = {
	'1': 'name', // 姓名
	'2': 'phone', // 手机号
	'3': 'company', // 机构
	'4': 'position', // 职位
	'5': 'email', // 邮箱
	'8': 'email', // 邮箱(含验证码)
	'7': 'question' // 留言
};
